import { OverlayTrigger, Popover } from "react-bootstrap";
import Icon from "../../../icons/Icon";
import { useEffect, useState } from "react";
import { CheckType } from "../../../functions/checkType";

const dontClosePopover = ['datetime', 'nested', 'many_nested_objects', 'color']

const FieldPopover = ({id, field, formIndex, popover, formattedValue, selectedValue, value, children}) => {
    const [show, setShow] = useState(false);
    useEffect(() => {
        if(selectedValue && !dontClosePopover.includes(field.template)){
            setShow(false)
        }
    }, [selectedValue])
    var popoverValue;
    if(field.template == 'nested' || field.template == 'many_nested_objects'){
        popoverValue = field.label;
    }
    else{
        popoverValue = selectedValue ? selectedValue : formattedValue  || value || field.label;
    }
    if(popover){
        return <OverlayTrigger
                    trigger="click"
                    onToggle={() => {setShow(!show)}}
                    show={show}
                    placement="right"
                    overlay={
                        <Popover 
                            id={`popover-${field.fieldName}-${formIndex}`}
                            className="field-popover"
                            style={{overflow: 'visible'}}
                            // rootClose={false}
                        >
                            <Popover.Body className="px-3 py-2">
                                <a type="button" className={"m-1 roundd"} onClick={() => setShow(false)}>
                                    <Icon name={"ICON_X"} />
                                </a>
                                {children}
                            </Popover.Body>
                        </Popover>
                    }
                >
                    {
                        <button 
                            type="button" 
                            className="btn btn-sm border  mx-2 d-flex align-items-center justify-content-between"
                            title={`Open ${field.label || field.name} in popover`}
                            onClick={() => setShow(true)}
                        >
                            {field.label}
                            <Icon name="ICON_CHEVRON_DOWN" />
                        </button>
                    }
                </OverlayTrigger>
    }
    return children
}

export default FieldPopover;